module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '0gsc062h',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
